export default __webpack_public_path__ + "static/media/rgp_pvh_nca_mangistau_region.0b4fa0fc.png";